export const scopeNames: Record<string, string> = {
    'navigation:read': 'Read storefront navigation menus and items',
    'navigation:write': 'Create, edit, reorder and delete storefront menus and items',
    'themes:read': 'Read theme drafts, files and private previews',
    'themes:write': 'Create, fork and edit private theme drafts',
    'themes:publish': 'Publish theme customizations and restore the previous theme',
    'customers:read': 'Read store customers and their order history',
    'orders:fulfill': 'Ship, ready for pickup, complete, return, or cancel/decline COD orders',
    'promotions:read': 'Read promotions and discount rules',
    'promotions:write': 'Create, edit or delete promotions',
    'additional_charges:read': 'Read delivery and additional charges',
    'additional_charges:write': 'Create, edit or delete additional charges',
    'announcements:read': 'Read store announcements',
    'announcements:write': 'Create, edit, publish, archive or delete announcements',
    'categories:read': 'Read product categories',
    'categories:write': 'Manage product categories and product assignments',
    'products:images': 'Assign, reorder or remove product and variant media',
    'products:variant_edit':
        'Edit variant identities and options, change the default and retire zero-stock variants',
    'product_outlets:read': 'Read product outlet assignments and stock',
    'product_outlets:write': 'Assign products to outlets or remove zero-stock assignments',
    'products:variants':
        'Add options and variants, including zero-stock assignment to existing product outlets',
    'products:create':
        'Create catalogue products with a default variant (no stock or outlet assignment)',
    'catalogue_pricing:write':
        'Edit catalogue/base variant prices (existing outlet prices stay unchanged)',
    'stores:read': 'View selected stores',
    'products:read': 'Read products in selected stores',
    'products:write': 'Edit product text and SEO',
    'inventory:read': 'Read stock at authorized outlets',
    'inventory:write': 'Set or adjust available stock at authorized outlets',
    'orders:read': 'Read orders and customer fulfillment details',
    'orders:accept': 'Accept orders awaiting merchant confirmation',
    'faqs:read': 'Read store FAQs and answers',
    'faqs:write': 'Create, edit, publish or delete FAQs',
    'collections:read': 'Read product collections and featured placements',
    'collections:write': 'Manage manual collections, membership and featured placements',
    'images:read': 'Browse images and current cover settings',
    'images:write': 'Upload images and replace store covers or collection images',
    'slots:read': 'Read delivery and pickup slots and outlet assignments',
    'slots:write': 'Create, edit and assign delivery and pickup slots',
    'delivery_areas:read': 'Read outlet coverage and slot delivery areas',
    'delivery_areas:write': 'Replace outlet coverage and slot delivery areas',
    'insights:read': 'Read sales metrics and top products and outlets',
    'pricing:read': 'Read assigned outlet variant prices',
    'pricing:write': 'Edit prices at authorized outlets',
    'store_profile:read': 'Read Super profile and discovery settings',
    'store_profile:write': 'Edit Super bio, WhatsApp, layout and discoverability',
    'store_operations:read': 'Read store settings and authorized outlet details',
    'store_operations:write': 'Update hours, annual holidays and temporary closures',
    offline_access: 'Stay connected while you are away',
};
export const scopeReads: Record<string, string> = {
    'themes:write': 'themes:read',
    'themes:publish': 'themes:write',
    'orders:fulfill': 'orders:read',
    'promotions:write': 'promotions:read',
    'additional_charges:write': 'additional_charges:read',
    'announcements:write': 'announcements:read',
    'categories:write': 'categories:read',
    'products:images': 'products:read',
    'products:variants': 'products:read',
    'products:variant_edit': 'products:read',
    'product_outlets:read': 'products:read',
    'product_outlets:write': 'product_outlets:read',
    'products:create': 'products:read',
    'catalogue_pricing:write': 'products:read',
    'pricing:write': 'pricing:read',
    'store_profile:write': 'store_profile:read',
    'store_operations:write': 'store_operations:read',
    'inventory:write': 'inventory:read',
    'orders:accept': 'orders:read',
    'faqs:write': 'faqs:read',
    'collections:write': 'collections:read',
    'images:write': 'images:read',
    'navigation:write': 'navigation:read',
    'slots:write': 'slots:read',
    'delivery_areas:write': 'delivery_areas:read',
};
export function toggleOptionalScope(
    current: string[],
    scope: string,
    checked: boolean,
    required: string[],
) {
    const next = new Set(current);
    if (checked) {
        let dependency: string | undefined = scope;
        while (dependency) {
            if (!required.includes(dependency)) next.add(dependency);
            dependency = scopeReads[dependency];
        }
    } else {
        next.delete(scope);
        const removed = new Set([scope]);
        let changed = true;
        while (changed) {
            changed = false;
            for (const [write, read] of Object.entries(scopeReads)) {
                if (next.has(write) && removed.has(read)) {
                    next.delete(write);
                    removed.add(write);
                    changed = true;
                }
            }
        }
    }
    return Array.from(next);
}
